import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useDeleteTransactionType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (transactionTypeId: string) => {
      await apiClient.transactionType.deleteTransactionType.mutation({ params: { id: transactionTypeId } });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transaction-types'] });
      toast.success('Transaction type deleted successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error deleting transaction type!');
    },
  });
};
